import { z } from 'zod';
/**
 * Shared vocabulary for every route. The API and the web client both import
 * these, so a field cannot drift on one side without breaking the other.
 */
/** Every non-2xx body, whatever the status. `error` is stable; `message` is for people. */
export const apiErrorSchema = z.object({
    error: z.string(),
    message: z.string(),
});
/** Dates cross the wire as ISO-8601. The API parses them back into Date at the edge. */
export const isoDateTime = z.iso.datetime();
/**
 * Two ways in, for two kinds of caller (docs/web-auth.md).
 *
 * People sign in with an emailed code and carry an httpOnly session cookie;
 * every non-GET request that relies on it must also send `x-fleet-client: web`.
 * A custom header cannot cross origins without a CORS preflight, which is what
 * makes it a CSRF check. The API key is for callers that are not people — ops,
 * monitoring — counts as a viewer, and may only read.
 */
export const API_KEY_HEADER = 'x-api-key';
export const CLIENT_HEADER = 'x-fleet-client';
export const WEB_CLIENT = 'web';
/**
 * Which workspace an API-key caller reads. A person's session already says
 * which workspace the panel is on, so the panel never sends it.
 */
export const WORKSPACE_HEADER = 'x-fleet-workspace';
/**
 * Both optional, and empty is treated as absent: ts-rest types a header as a
 * string, so a client that has no key sends "" rather than leaving it out.
 */
export const authHeaders = {
    [API_KEY_HEADER]: z.string().optional(),
    [CLIENT_HEADER]: z.string().optional(),
    [WORKSPACE_HEADER]: z.string().optional(),
};
/**
 * Who may call a route. Each level includes the ones before it; an API key is a
 * viewer. Declared on every route as `metadata: access(...)` — the API builds
 * its guard table from it, and a test fails if a route has none.
 *
 * `account` is anybody signed in, whether or not they are in a workspace yet:
 * signing out, and creating, choosing or joining one. Every level above it is
 * a role in the workspace the request is for.
 */
export const ACCESS_LEVELS = ['public', 'account', 'viewer', 'dispatcher', 'admin'];
export const access = (level) => ({ access: level });
//# sourceMappingURL=common.js.map